import { render, staticRenderFns } from "./DialogAddBo.vue?vue&type=template&id=397b266c&scoped=true&"
import script from "./DialogAddBo.vue?vue&type=script&lang=js&"
export * from "./DialogAddBo.vue?vue&type=script&lang=js&"
import style0 from "./DialogAddBo.vue?vue&type=style&index=0&id=397b266c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397b266c",
  null
  
)

export default component.exports